export const FEATURE_FLAG = {
  QR_HU_CONNECT_ENABLED: "QR-HU-CONNECT-ENABLED",
};
